export function engineConfigurationState(hasAssignment: boolean): 'configured' | 'needs-configuration' {
  return hasAssignment ? 'configured' : 'needs-configuration'
}

export function engineConfigurationAction(hasAssignment: boolean): 'View / edit configuration' | 'Configure' {
  return hasAssignment ? 'View / edit configuration' : 'Configure'
}

export function engineEmptyStateMessage(): string {
  return 'Deploy the SIP engine; it will appear here automatically.'
}
